export const COLLECTION_KEY = "stickySettings";

export const defaultConstruct = <T>(value: unknown) => value as T;
